import { Routes } from '@angular/router';

import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePageComponent),
    canActivate: [authGuard],
  },
  {
    path: 'group-distribution',
    loadComponent: () =>
      import('./pages/group-distribution/group-distribution.page').then(
        m => m.GroupDistributionPageComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPageComponent),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./pages/unauthorized/unauthorized.page').then(m => m.UnauthorizedPageComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.page').then(m => m.NotFoundPageComponent),
  },
];
